import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";

const ProcessData = ({ devicesData, handleVisble, closePane, offset }) => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    const list = devicesData.diyAttrList ? [...devicesData.diyAttrList] : [];
    setDataList(list);
  }, [devicesData]);

  return (
    <div
      className="process-data"
      style={{
        position: "absolute",
        zIndex: 99,
        top: offset.top + 60,
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <div className="state-box">
        <div className="state-box-header">
          {devicesData.processunitName}
          <div onClick={closePane}>
            <CloseOutlined />
          </div>
        </div>
        <div className="state-box-content" style={{ height: "108px" }}>
          {dataList.map((item, subIndex) => {
            return (
              <div
                className="state-box-content-item"
                key={subIndex}
                onClick={handleVisble}
              >
                <div className="txt-info">
                  {item.type == 1 && (
                    <span
                      className={
                        item.value == 1
                          ? "status-tip-circle green"
                          : "status-tip-circle red"
                      }
                    ></span>
                  )}
                  <span className="txt" title={item.attrName}>
                    {item.attrName}
                  </span>
                </div>
                <div>
                  {item.type == 1 && (
                    <div
                      className={
                        item.value == 1
                          ? "state-box-content-tag zhengchang-state"
                          : "state-box-content-tag yichang-state"
                      }
                    >
                      {item.value == 1 ? "启动" : "停止"}
                    </div>
                  )}
                  {item.type == 2 && (
                    <div className="state-box-val">
                      {item.value}
                      {item.unit}
                    </div>
                  )}
                  {item.type == 3 && (
                    <div className="state-box-val">{item.value}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className={"state-line-box top"}
          style={{ width: 72, left: 16, top: -32 }}
        >
          <div className="state-line"></div>
          <div className="state-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default ProcessData;
